import { render, staticRenderFns } from "./RecruiterCompanyDescription.vue?vue&type=template&id=e7f9baf2&scoped=true"
import script from "./RecruiterCompanyDescription.vue?vue&type=script&lang=ts"
export * from "./RecruiterCompanyDescription.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterCompanyDescription.vue?vue&type=style&index=0&id=e7f9baf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f9baf2",
  null
  
)

export default component.exports